import React, { useState } from "react";
import { Helmet } from "react-helmet";

const BeATrainerGetStarted = () => {
  const [isLoading, setIsLoading] = useState(true);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <div>
      <Helmet>
        <title>Utiva | Be A Trainer</title>
      </Helmet>

      <section className="relative" style={{ background: "#050545" }}>
        <div className="mx-auto">
          <div className="w-full relative">
            {isLoading && (
              <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center rounded-2xl z-10 h-screen w-full">
                <div className="text-center">
                  <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-white mb-4"></div>
                  <p className="text-white text-lg">Loading form...</p>
                </div>
              </div>
            )}
            <iframe
              title="Best"
              aria-label="What Is the Best Skill To Learn"
              frameborder="0"
              width={"100%"}
              height={1800}
              src="https://forms.zohopublic.com/utiva/form/JoinOurTeam/formperma/s3DOSWogPyC3eiD0bOFPJAu0qST4aD7j6xCxgcHW_r0"
              onLoad={handleIframeLoad}
              style={{
                opacity: isLoading ? 0 : 1,
                transition: "opacity 0.3s ease-in-out",
              }}
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BeATrainerGetStarted;
